module.exports = __webpack_public_path__ + "static/mo31-62cf36c721414a6ff730bf62b7a34660.png";